import {ref,computed, onMounted} from 'vue'
import {useStore} from 'vuex'

import MegaMenu from './SiteNavigationMegaMenu.vue'

export default {
    name: "SiteNavigationMegaMenu",
    components:{
        MegaMenu
    },
    setup(){
        const store = useStore()
        const menuData = computed(()=>store.getters['main/getMegaMenuData'])
        const spotData = computed(()=>store.state.main.mega_menu_data.spots)

        const hideMegaMenu = function(){
            store.dispatch('main/closeMegaMenu')
        }

        const hideMegaMenuOnresize = () => {
            if(window.innerWidth < 1001) hideMegaMenu()
        }

          const beforeEnter = (el) => {
            el.style.height = '0';
            el.style.opacity = '0';
        };

        const enter = (el, done) => {
            const height = el.scrollHeight + 'px';

            el.style.transition = 'height 400ms cubic-bezier(0.25, 0.1, 0.25, 1), opacity 400ms ease, padding-top 400ms ease';
            el.style.height = '0';
            el.style.opacity = '0';

            requestAnimationFrame(() => {
                el.style.height = height;
                el.style.opacity = '1';
            });

            setTimeout(() => {
                el.style.transition = '';
                el.style.height = '';
                el.style.opacity = '';
                done();
            }, 200);
        };

        const leave = (el, done) => {
            el.style.transition = 'height 300ms cubic-bezier(0.25, 0.1, 0.25, 1), opacity 200ms ease, padding-top 600ms ease';
            el.style.height = el.scrollHeight + 'px';
            el.style.opacity = '1';
            el.style.paddingTop = getComputedStyle(el).paddingTop;

            requestAnimationFrame(() => {
                el.style.height = '0';
                el.style.opacity = '0';
                el.style.paddingTop = '15px'; 
            });

            setTimeout(() => {
                el.style.transition = '';
                el.style.height = '';
                el.style.opacity = '';
                el.style.paddingTop = '';
                done();
            }, 300);
        };


        onMounted(()=>{

            const isMobile = 768
            if (window.innerWidth > isMobile) {
                store.dispatch('main/windowOnresize',hideMegaMenuOnresize)
            }

            /**
             * Reason for this check:
             * There is currently a bug on Android devices, on which the window.onresize function, within the action
             * 'windowOnresize', will fire on mount, although no re-size had occured. This multi-function call causes issues for 
             * different boolean view states. 
             * 
             * There is no reason to hide megamenu on resize on mobile, as you can't resize the window on these devices anyway.
             */ 
        })

        return {
            hideMegaMenu,
            menuData,
            spotData,
            beforeEnter,
            enter,
            leave
        }
    }
}